import { useMemo, useState } from 'react';
import { CODE_SUCCESS } from '@features/constants/network';
import {
  BannerType,
  GetBannerV2ResponseData,
  sellerLearningCenterApiClient,
} from '@/api/seller/serv/oec_seller_learning_center_api';

export const useBannerModel = () => {
  const [bannerData, setBannerData] = useState<GetBannerV2ResponseData>({});

  const state = {
    banners: useMemo(() => {
      return bannerData.banner_info || [];
    }, [bannerData]),

    interval: bannerData.display_interval || 6000,
  };

  const actions = {
    fetch: async () => {
      const res = await sellerLearningCenterApiClient.GetBannerV2({
        type: BannerType.Home,
      });

      setBannerData(
        res.code === CODE_SUCCESS && res.data ? (res.data ?? {}) : {},
      );
    },
  };

  return {
    ...state,
    ...actions,
  };
};
